import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  Button, Form, Header, Message,
} from 'semantic-ui-react';
import ErrorType from './types/error_type';
import { clearError as sessionClearError, setCredentialData } from '../modules/session';
import { clearError as accountClearError, sendCreateAccountRequest } from '../modules/account';

import CenterCard from './center_card';

import Loading from './loader_wave';
import ErrorMessage from './error_message';
import getParams from './utils/getParams';

class Create extends Component {
  constructor() {
    super();

    this.state = {
      submitted: false,
      parameters: getParams(window.location),
    };
  }

  componentDidMount() {
    const {
      connectedSessionClearError, connectedAccountClearError, connectedSetCredentialData,
    } = this.props;
    const { parameters } = this.state;
    connectedAccountClearError();
    connectedSessionClearError();
    if (parameters.email) {
      connectedSetCredentialData('email', parameters.email);
      this.submitCredentials();
    }
  }

  componentWillUnmount() {
    const {
      connectedSessionClearError, connectedAccountClearError,
    } = this.props;
    connectedAccountClearError();
    connectedSessionClearError();
  }

  setCredentialData(event) {
    const { connectedSetCredentialData } = this.props;
    connectedSetCredentialData(event.target.name, event.target.value);
  }

  createSuccess = () => {
    const { submitted } = this.state;
    const { error, createAccountRequestOut } = this.props;
    return submitted && !createAccountRequestOut && !error;
  }

  submitCredentials(event) {
    const { connectedSendCreateAccountRequest } = this.props;
    if (event) {
      event.preventDefault();
    }

    this.setState({
      submitted: true,
    });
    connectedSendCreateAccountRequest();
  }

  renderSubmitArea = () => {
    const { submitted } = this.state;
    const { createAccountRequestOut } = this.props;

    return (
      <div>
        { submitted && createAccountRequestOut
          ? <Loading />
          : (
            <Button
              primary
              type="submit"
            >
              Sign up
            </Button>
          ) }
        <div className="re is-flex is-flex-row-justify-end is-marginTop-16px">
          {/* <Link to="/forgot">Forgot password?</Link> */}
          {/* <Link to="/signin">Sign in</Link> */}
        </div>
      </div>
    );
  }

  renderSuccessMessage = (email) => (
    <>
      <p>
        We&apos;ve sent an email to
        {' '}
        <b>{email}</b>
        {' '}
        to verify your account.
      </p>
      <Message positive>
        <p>
          Please check your inbox, and possibly your spam folder.
        </p>
      </Message>
    </>
  )

  renderForm = (email) => {
    const { submitted } = this.state;
    const { createAccountRequestOut } = this.props;

    return (
      <Form className="sign-up" onSubmit={(event) => { this.submitCredentials(event); }}>
        <Header>
          Remeeting is cloud storage for Zoom recordings
        </Header>
        <p>
          { submitted && createAccountRequestOut ? 'Signing up...' : 'Do you want to try it?' }
        </p>
        <Form.Input type="email" name="email" placeholder="Email address" value={email} onChange={(event) => { this.setCredentialData(event); }} required />
        { this.renderSubmitArea() }
      </Form>
    );
  }

  render() {
    const { email, error, routeName } = this.props;
    return (
      <CenterCard routeName={routeName}>
        { this.createSuccess()
          ? this.renderSuccessMessage(email)
          : this.renderForm(email) }
        { error && <ErrorMessage message="Unable to create an account for that email." /> }
      </CenterCard>
    );
  }
}

Create.propTypes = {
  connectedAccountClearError: PropTypes.func.isRequired,
  connectedSendCreateAccountRequest: PropTypes.func.isRequired,
  connectedSessionClearError: PropTypes.func.isRequired,
  connectedSetCredentialData: PropTypes.func.isRequired,
  createAccountRequestOut: PropTypes.bool.isRequired,
  email: PropTypes.string,
  error: ErrorType,
  routeName: PropTypes.string.isRequired,
};

Create.defaultProps = {
  email: '',
  error: undefined,
};

const mapStateToProps = (state) => ({
  createAccountRequestOut: state.account.createAccountRequestOut,
  email: state.session.email,
  error: state.account.error,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  connectedAccountClearError: accountClearError,
  connectedSendCreateAccountRequest: sendCreateAccountRequest,
  connectedSessionClearError: sessionClearError,
  connectedSetCredentialData: setCredentialData,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Create);
